import moment from 'moment-timezone';

import type {UserReportApiResponse} from '~/shared/services/apiService/models';

export const isAllowedToStepBackward = (
  userCreated?: UserReportApiResponse['userCreated'],
  currentReportStartDate?: string,
): boolean => {
  if (!currentReportStartDate || !userCreated) {
    return false;
  }

  const startDate = moment(currentReportStartDate, 'DD/MM/YYYY');
  const userCreatedDate = moment(userCreated);
  
  return userCreatedDate.isBefore(startDate, 'day');
};
